<h1 mat-dialog-title>{{'Select or create new tag' | translate}}</h1>
<div mat-dialog-content>
    <mat-form-field class="example-form-field" appearance="fill">
        <mat-label>{{'Tag text' | translate}}:</mat-label>
        <input matInput type="text" [(ngModel)]="value" (ngModelChange)="filterTag($event)">
        <button *ngIf="value && !filteredTags.length" matSuffix mat-icon-button aria-label="add" (click)="addTag()">
            <mat-icon>add_circle</mat-icon>
        </button>
        <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <div class="tags-container">
        <div *ngFor="let tag of filteredTags" class="tag">
            <a (click)="selectTag(tag)">
                {{tag.value}}
            </a>

            <a (click)="removeTag(tag)" class="remove">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <!-- <button mat-raised-button color="primary" [mat-dialog-close]="true">
        Add
    </button> -->
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
</div>